export default class TouristTaxRecord {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.taxableNights = apiResponse.taxableNights ? Number.parseInt(apiResponse.taxableNights) : null;
        this.taxableGuestsCount = apiResponse.taxableGuestsCount ? Number.parseInt(apiResponse.taxableGuestsCount) : 0;
        this.excludedGuestsCount = apiResponse.excludedGuestsCount ? Number.parseInt(apiResponse.excludedGuestsCount) : 0;
        this.unitPrice = apiResponse.unitPrice ? Number.parseFloat(apiResponse.unitPrice) : null;
        this.totalAmount = apiResponse.totalAmount ? Number.parseFloat(apiResponse.totalAmount) : null;
    }

    clone() {
        const payment = new TouristTaxRecord({});
        payment.id = this.id;
        payment.taxableNights = this.taxableNights;
        payment.taxableGuestsCount = this.taxableGuestsCount;
        payment.excludedGuestsCount = this.excludedGuestsCount;
        payment.unitPrice = this.unitPrice;
        payment.totalAmount = this.totalAmount;
        return payment;
    }
}